<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">

        <div class="col-12  mt-2 py-0">
          <h4 class="m-0 p-0 text-secondary d-inline">Laporan penjualan lain</h4>

          <b-button v-b-modal.modal-pdf class="btn btn-warning mx-3 mb-1" title="Print"><b-icon icon="printer"></b-icon></b-button>
          <b-button class="btn btn-success mx-1 mb-1" title="Print Excel" v-on:click="getOtherExcel()"><b-icon icon="printer"></b-icon></b-button>
          <b-modal no-close-on-esc  content-class="m-0"  id="modal-pdf" title="Cetak laporan penjualan lain" scrollable no-close-on-backdrop  size="lg">
            <b-container>
              <b-row>
                <div class="col-12 col-md-6 col-lg-4 mt-2" style="height:80px">
                  <div style="position:fixed;z-index:1100">
                    <label class="d-block">Tanggal mulai <span style="color:red;">*</span></label>
                    <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" id="datepicker-start-print" class="mb-2" v-model="printPDF.start">{{printPDF.start}}</b-form-datepicker>
                  </div>    
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <div style="position:fixed;z-index:1000">
                    <label class="d-block">Tanggal selesai <span style="color:red;">*</span></label>
                    <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" id="datepicker-end-print" class="mb-2"  v-model="printPDF.end">{{printPDF.end}}</b-form-datepicker>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 my-2 d-flex align-items-end">
                  <button class="btn btn-primary" type="button" v-on:click="savePDF"><span v-if="savingPDF" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Submit</button>
                </div>
              </b-row>
            </b-container>
            <template #modal-footer>
              <div class="w-100 text-right m-0 p-0">
                <hr>
                <b-button class="btn btn-secondary" @click="(!deleteState)?$bvModal.hide('modal-pdf'):''">Tutup</b-button>
              </div>
            </template>
          </b-modal>

          <br>
          <br>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4 mt-2">
              <label class="d-block">Tanggal mulai <span style="color:red;">*</span></label>
              <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" id="datepicker-start" class="mb-2" v-model="searchListing.start">{{searchListing.start}}</b-form-datepicker>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mt-2">
              <label class="d-block">Tanggal selesai <span style="color:red;">*</span></label>
              <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" id="datepicker-end" class="mb-2"  v-model="searchListing.end">{{searchListing.end}}</b-form-datepicker>
            </div>
            <div class="col-12 col-md-6 col-lg-4 my-2 d-flex align-items-end">
              <button class="btn btn-primary" type="button" v-on:click="saveListing"><span v-if="savingListing" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Submit</button>
            </div>
            
          </div>
        </div>

        <div class="col-12 my-2 py-0"> <!--LAPORAN PENJUALAN LAIN-->
          <chart-card
            v-if="otherHistoryReady"
            :chart-data="otherHistories.data"
            :chart-options="otherHistories.options"
            :chart-responsive-options="otherHistories.responsiveOptions"
            chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">Laporan penjualan lain</h4>
              <div class="col-6 col-md-3 col-lg-3 my-2 text-left">
                <select class="custom-select custom-select-sm" @change="refetchOther" v-model="selectedOtherYear">
                  <option v-for="(item,idx) in OtherYears" v-bind:key="'itemotheryear'+idx">{{item.year}}</option>
                </select>
              </div>
            </template>
          </chart-card>
        </div>

        <div class="col-12 my-2 py-0">
          <div class="row">
            <div class="col-3">
              <select class="custom-select custom-select-sm" v-model="rowLimit" v-on:change="getOthers()">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
          <datatable 
          :currentIdx="currentPage"
          :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
          use-filter
          no-toolbar :datas="others" :structure="TableStructure" :init="loadData" use-seeker seeker-url="/api/report/json/other-sales" @searching="(val)=>!val.status?getOthers():others=val.data">
              <template #customcell={obj,index}>
                  <td v-if="isMobile" class="py-3">
                      <ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
                          <li class="mt-2">
                              <div class="text-left mx-3 pt-0">
                                  <small class="my-0 py-0">Tanggal invoice:</small>
                                  <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.invoice_date | timeformat }}</b>
                              </div>
                              <hr class="my-1">
                              <div class="text-left mx-3 pt-0">
                                  <small class="my-0 py-0">Nomor invoice:</small>
                                  <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.invoice_no }}</b>
                              </div>
                              <div class="text-left mx-3 pt-0">
                                  <small class="my-0 py-0">Total (IDR):</small>
                                  <br><b class="py-0 mx-0" style="font-size:10pt">Rp {{ obj.total | numeral('0,0') }}</b>
                              </div>
                          </li>
                      </ul>
                  </td>
                  <td v-if="!isMobile" >{{ index+ 1 }}</td>
                  <td v-if="!isMobile" >{{ obj.invoice_date | timeformat }}</td>
                  <td v-if="!isMobile" >{{ obj.invoice_no }}</td>
                  <td v-if="!isMobile" >Rp {{ obj.total | numeral('0,0') }}</td>
                  <!-- <td v-if="!isMobile" >{{ obj.invoice_metadata[0].order_metadata.hardware_setup.id_transmitter }}</td>
                  <td v-if="!isMobile" >{{ obj.client.legal_name }}</td>
                  <td v-if="!isMobile" >{{ obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.name }}</td> -->
              </template>
          </datatable>
        </div>


      </div>
    </div>
  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import * as axios from 'axios';
    import moment from 'moment';
    import Datatable from '../../components/Datatable.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    import ModalDelete from '../../components/ModalDelete.vue';
    import ChartCard from 'src/components/Cards/ChartCard.vue';
    import StatsCard from 'src/components/Cards/StatsCard.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'modal-delete':ModalDelete,
            ChartCard,
            StatsCard
        },
        data () {
            return {
                currentPage: 1,
                perPage: null,
                rowLimit: 10,
                nextUrl: null,
                prevUrl: null,
                months: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                loadDataOtherYear:true,
                OtherYears:{},
                otherHistoryReady:false,
                loadDataOther:true,
                //step 1 edit
                isMobile:false,
                dataEdit:null,
                deleteId:0,
                createErrorMessage:'Gagal Menyimpan Data Aplikasi Baru.',
                errorMessages:[],
                itemToDelete:{},
                others:[],
                searchValue:'',
                loadData:true,
                savingListing:false,
                errorSearchListing:false,
                errorList:[],
                errorApplicationSaved:false,
                savedListing:false,
                updateApplicationState:false,
                updateApplicationSaved:false,
                selectedApplication:0,
                selectedTab:0,
                updateApplicationCol:6,
                searchListing:{
                  start:'',
                  end:'',
                },
                printPDF:{
                  start:'',
                  end:'',
                },
                formApplicationActive:false,
                TableStructure:[
                    //label: nama heading, key: nama object property
                    {label:'No',key:null},
                    {label:'Tanggal invoice',key:null},
                    {label:'Nomor invoice',key:null},
                    {label:'Total (IDR)',key:null},
                    // {label:'ID transmitter',key:null},
                    // {label:'Pelanggan',key:null},
                    // {label:'Nama kapal',key:null}
                ],
                otherHistories: {
                  data: {
                    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    series: [[1]]
                  },
                  options: {
                    seriesBarDistance: 10,
                    axisX: {
                      showGrid: false
                    },
                    height: '245px'
                  },
                  responsiveOptions: [
                    ['screen and (max-width: 640px)', {
                      seriesBarDistance: 5,
                      axisX: {
                        labelInterpolationFnc (value) {
                          return value[0]
                        }
                      }
                    }]
                  ]
                },
            }
        },
        created(){
            console.clear()
            this.$reActivateAccess(this) /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
            console.log("user page")
            this.getOthers();
            this.isMobile = this.$isMobile
            window.addEventListener('resize', ()=>{
                console.log('screen update')
                this.isMobile = screen.width < 768
            });
            if(!localStorage.getItem('accessToken')){
              this.$router.push('/login')
              }else{
                this.getReportOther();
                 this.getReportOtherYear();
              }
            console.log("Kata ary tahun sekarang: "+moment().year())
            this.selectedOtherYear = moment().year();
            // var newData = [];
            // for(var x=0;x<100;x++){
            //     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
            // }
            // console.log(newData);
            // this.users = newData;
        },
        methods:{
            changePage(isNext) {
              var url = (isNext ? this.nextUrl : this.prevUrl);
              let params = (new URL(url)).searchParams;
              const myParams = params.get("page");
              this.currentPage = myParams;
              var newUrl = this.$baseUrl + "/api/report/json/other-sales?limit=" + this.rowLimit + "&page=" + myParams;
              this.getOthers(newUrl);
            },
            refetchOther(el){
              console.log('target year: '+el.target.value)
              this.otherHistoryReady = false
              this.getReportOther(this.$baseUrl+'/api/report/graph-data/invoice-lain?year='+el.target.value)
            },
            getReportOther(url=(this.$baseUrl+'/api/report/graph-data/invoice-lain')){ //FUNCTIONAL GRAPH LAPORAN PENJUALAN LAIN
              this.loadDataOther=true
              axios.get(url,{'headers':{
                  'Authorization':'Bearer '+localStorage.getItem('accessToken')
                }
              }
              ).then((result)=>{
                console.log(result)
                //this.vesselTotal = result.data;

                var seriesOne = []
                var labels = []
                for(var x=0;x<result.data.length;x++){
                  labels.push(this.months[result.data[x].month-1])
                  seriesOne.push(result.data[x].total)
                }
                this.otherHistories.data.labels=labels
                this.$set(this.otherHistories.data.series, 0,seriesOne)
                
                
                //this.otherHistories.data.series[0]=seriesOne

                console.log(this.otherHistories.data.labels)
                console.log(this.otherHistories.data.series)
                this.loadDataOther=false
                this.otherHistoryReady=true
                this.$forceUpdate()
              }).catch((err)=>{
                //check if token fail
                if(err.response && err.response.status==401){
                  localStorage.removeItem('accessToken')
                this.$router.push('/login')
                }
                console.log(err)
                this.loadDataOther=false
              })
            },
            getReportOtherYear(url=(this.$baseUrl+'/api/report/graph-data/invoice-lain-sample')){ //FUNCTIONAL GRAPH LAPORAN PENJUALAN LAIN YEAR
              this.loadDataOtherYear=true
              axios.get(url,{'headers':{
                  'Authorization':'Bearer '+localStorage.getItem('accessToken')
                }
              }
              ).then((result)=>{
                console.log(result)
                this.OtherYears = result.data;
                this.loadDataOtherYear=false
              }).catch((err)=>{
                //check if token fail
                if(err.response && err.response.status==401){
                  localStorage.removeItem('accessToken')
                this.$router.push('/login')
                }
                console.log(err)
                this.loadDataOtherYear=false
              })
            },
            getOthers(url=(this.$baseUrl+'/api/report/json/other-sales?limit='+this.rowLimit)){
              this.loadData=true
              axios.get(url,{'headers':{
                      'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                  console.log("get di sini")
                  console.log(result.data.data)
                  this.prevUrl = result.data.prev_page_url;
                  this.nextUrl = result.data.next_page_url;
                  this.currentPage = result.data.current_page;
                  this.perPage = parseInt(result.data.per_page);
                  this.others = result.data.data;
                  this.loadData=false
              }).catch((err)=>{
                  //check if token fail
                  if(err.response && err.response.status==401){
                    localStorage.removeItem('accessToken')
                  this.$router.push('/login')
                  }
                  console.log(err)
                  this.loadData=false
              })
            },
            getOtherExcel(){
              this.loadDataExcel=true
              
              axios.get(this.$baseUrl+'/api/report/excel/other-sales',{
                  'responseType':'blob',
                  'headers':{
                    'Authorization':'Bearer '+localStorage.getItem('accessToken'),
                      
                  }
              }).then((result)=>{
                  console.log("get di sini")
                  // console.log(result.data.data)
                  // this.unitreportexcels = result.data.data;

                  this.downloadEXCEL(result.data,'other-sales-report.xlsx')
                  this.loadDataExcel=false
                  
              }).catch((err)=>{
                  //check if token fail
                  if(err.response && err.response.status==401){
                    localStorage.removeItem('accessToken')
                  this.$router.push('/login')
                  }
                  console.log(err)
                  this.loadDataExcel=false
                  
              })
            },
            downloadEXCEL(data,filename = "file.xlsx"){
              const url = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename); //or any other extension
              document.body.appendChild(link);
              link.click();
            },
            saveListing(){
                this.savingListing=true
                // this.errorSearchListing=false
                console.log(this.searchListing)
                axios.post(this.$baseUrl+'/api/report/json/other-sales', this.searchListing,
                {
                    'headers':
                    {
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    console.log(result)
                    this.others = result.data.data;
                    //this.getAirtimes();
                    this.savingListing=false
                    // this.savedListing=true
                    setTimeout(() => {
                        // this.savedListing=false
                        // this.formApplicationActive=false
                    }, 1000);

                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                      localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err.response)
                    this.errorList=[]
                    this.errorList=Object.values(err.response.data.errors)
                    console.log(this.errorList)
                    // this.errorSearchListing=true
                    this.savingListing=false
                })
            },
            downloadPDF(data,filename = "file.pdf"){
              const url = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename); //or any other extension
              document.body.appendChild(link);
              link.click();
            },
            savePDF(){
                this.savingPDF=true
                // this.errorSearchListing=false
                console.log(this.printPDF)
                axios.post(this.$baseUrl+'/api/report/kwitansi', this.printPDF,
                {
                    'responseType':'blob',
                    'headers':
                    {
                        'Authorization':'Bearer '+localStorage.getItem('accessToken'),
                    }
                }).then((result)=>{
                    console.log(result)
                    this.downloadPDF(result.data,'kwitansi-report.pdf')
                    //this.others = result.data;
                    //this.getOthers();
                    this.savingPDF=false
                    // this.savedListing=true
                    setTimeout(() => {
                        // this.savedListing=false
                        // this.formApplicationActive=false
                    }, 1000);

                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                      localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err.response)
                    this.errorPDF=[]
                    this.errorPDF=Object.values(err.response.data.errors)
                    console.log(this.errorPDF)
                    // this.errorSearchListing=true
                    this.savingPDF=false
                })
            }
        }
    }
</script>
<style scoped>
::v-deep .modal-content {
    margin: -3.25rem auto;
}

.btn {
    padding : 2px 6px;
}
</style>
